export default __webpack_public_path__ + "static/media/factory__27.32bdff94.jpg";